// src/app/configs/service.ts

import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })
export class Service {
  private Key = environment.k;
  private Cli = environment.c;
  //private base = SITEVISITORLOG_POST().apiUrl;  // e.g. 'https://portal2websiteapi.cloudcampus24.com'

  constructor(private http: HttpClient) {}

  /** Generic GET */
  get(url: string): Observable<any> {
    const authToken = localStorage.getItem('accessToken');
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${authToken}`
    });
    return this.http.get(url, { headers });
  }

  /** Generic POST */
  post(url: string, body: any): Observable<any> {
    const authToken = localStorage.getItem('accessToken');
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${authToken}`
    });
    return this.http.post(url, body, { headers });
  }

  /** Generic POST FormData */
  postFormData(url: string, body: any): Observable<any> {
    const authToken = localStorage.getItem('accessToken');
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${authToken}`
    });
    return this.http.post(url, body, { headers });
  }

  /** Generic PUT */
  put(url: string, body: any): Observable<any> {
    const authToken = localStorage.getItem('accessToken');
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${authToken}`
    });
    return this.http.put(url, body, { headers });
  }

  /** Generic DELETE */
  delete(url: string): Observable<any> {
    const authToken = localStorage.getItem('accessToken');
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${authToken}`
    });
    return this.http.delete(url, { headers });
  }

  /** App-Key GET */
  getKey(url: string): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'X-App-Key': this.Key,
      'X-App-Client': this.Cli
    });
    return this.http.get(url, { headers });
  }

  // ────────────────────────────────────────────
  // Visitor Counter Endpoints (from Swagger)
  // ────────────────────────────────────────────

 

  /** GET /api/v{v}/SiteVisitorLog/count?pageName=...&menuId=... */
  getVisitorCount(url:any,
    pageName: string,
    menuId?: number,
    version: string = '1'
  ): Observable<any> {
    //const url = `${this.base}/api/v${version}/SiteVisitorLog/count`;
    let params = new HttpParams().set('pageName', pageName);
    if (menuId != null) {
      params = params.set('menuId', menuId.toString());
    }
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'X-App-Key': this.Key,
      'X-App-Client': this.Cli
    });
    return this.http.get(url, { headers, params });
  }

  /** Optional: POST with Bearer auth */
  postVisitorLog(url:any,version: string = '1'): Observable<any> {
    //const url = `${this.base}/api/v${version}/SiteVisitorLog/log`;
    // const authToken = localStorage.getItem('accessToken');
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'X-App-Key': this.Key,
      'X-App-Client': this.Cli
    });
    const body = {  };
    return this.http.post(url, body, { headers });
  }
/** GET /api/v1/SiteVisitorLog/summary */
getVisitorSummary(url: any): Observable<any> {
  const headers = new HttpHeaders({
    'Content-Type': 'application/json',
    'X-App-Key': this.Key,
    'X-App-Client': this.Cli
  });
 return this.http.get(url, { headers });
}

  
}
